import React from 'react';
import { Box, CardActions, CardHeader, Container, Typography } from '@mui/material';
import PrimaryButton from '../../common/components/PrimaryButton';
import useDataExport from '../hooks/useDataExport';
import CardWithBoxShadow from '../../common/components/CardWithBoxShadow';

const SUCCESS_MESSAGE =
    "Your export is being prepared. We'll email a download link when it's finished. The link expires in 48 hours.";

export default function DataExport() {
    const {
        exportUserData,
        exportMedia,
        isLoading,
        isMediaLoading,
        isSuccess,
        isMediaSuccess,
        errorMessage,
        mediaErrorMessage
    } = useDataExport();

    return (
        <Box className="outer-container with-nav">
            <Container maxWidth="lg">
                <Box className="management-header">
                    <header>
                        <h1 className="title">Export Data</h1>
                    </header>
                </Box>
                <CardWithBoxShadow data-testid="card" classes={{ root: 'form-card card current-plan' }}>
                    <CardHeader
                        title="Download your training data, messages, etc."
                        classes={{
                            root: 'padding-desktop',
                            title: 'card-title'
                        }}
                    />
                    {isSuccess && (
                        <Box sx={{ textAlign: 'left', p: 4 }}>
                            <Typography>{SUCCESS_MESSAGE}</Typography>
                        </Box>
                    )}
                    {!isLoading && errorMessage && (
                        <Box sx={{ textAlign: 'left', p: 4 }}>
                            <Typography color="error">{errorMessage}</Typography>
                            <a
                                href="https://support.trainheroic.com/hc/en-us"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Please contact the TrainHeroic Support Team for assistance.
                            </a>
                        </Box>
                    )}
                    <CardActions classes={{ root: 'action-container' }}>
                        <Box className="action-buttons-container">
                            <PrimaryButton onClick={exportUserData} disabled={isLoading || isMediaLoading || isSuccess}>
                                {isLoading ? 'Exporting...' : 'Export User Data'}
                            </PrimaryButton>
                        </Box>
                    </CardActions>
                </CardWithBoxShadow>

                <CardWithBoxShadow data-testid="card" classes={{ root: 'form-card card current-plan' }}>
                    <CardHeader
                        title="Download your media files"
                        classes={{
                            root: 'padding-desktop',
                            title: 'card-title'
                        }}
                    />
                    {isMediaSuccess && (
                        <Box sx={{ textAlign: 'left', p: 4 }}>
                            <Typography>{SUCCESS_MESSAGE}</Typography>
                        </Box>
                    )}
                    {!isMediaLoading && mediaErrorMessage && (
                        <Box sx={{ textAlign: 'left', p: 4 }}>
                            <Typography color="error">{mediaErrorMessage}</Typography>
                            <a
                                href="https://support.trainheroic.com/hc/en-us"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Please contact the TrainHeroic Support Team for assistance.
                            </a>
                        </Box>
                    )}
                    <CardActions classes={{ root: 'action-container' }}>
                        <Box className="action-buttons-container">
                            <PrimaryButton
                                onClick={exportMedia}
                                disabled={isMediaLoading || isLoading || isMediaSuccess}
                            >
                                {isMediaLoading ? 'Exporting...' : 'Export Media'}
                            </PrimaryButton>
                        </Box>
                    </CardActions>
                </CardWithBoxShadow>
            </Container>
        </Box>
    );
}
